/* Wraps the entire "details" section and renders children vertically. */
.detailsContainer {
    display: flex;
    flex-direction: column;
}

/* Renders multiple evenly-spaced columns. Immediate descendants should be of the `detailsGridColumn` class. */
.detailsGridSection {
    display: flex;
    justify-content: space-between;
    max-width: 60%;
}

.detailsGridColumn {
    display: flex;
    flex-direction: column;
}

/* This class should wrap any field label + field value pair in the "details" section. Standardizes spacing between children of the details container. */
.labelAndValueContainer {
    margin-bottom: 20px;
}
